import { render, staticRenderFns } from "./KimPlayerComponent.vue?vue&type=template&id=990f5a4c&scoped=true"
import script from "./KimPlayerComponent.vue?vue&type=script&lang=ts"
export * from "./KimPlayerComponent.vue?vue&type=script&lang=ts"
import style0 from "./KimPlayerComponent.vue?vue&type=style&index=0&id=990f5a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990f5a4c",
  null
  
)

export default component.exports